/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::293e410a525bc2269873fca060cc05c2>>
 * @codegenCommand yarn build tokens
 */
const tokens = [
  {
    "attributes": {
      "group": "raw",
      "state": "active",
      "introduced": "1.20.1",
      "description": "Text transform uppercase token used for backwards compatibility between new and old theming solutions"
    },
    "value": "uppercase",
    "filePath": "schema/themes/atlassian-typography-adg3/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "raw",
        "state": "active",
        "introduced": "1.20.1",
        "description": "Text transform uppercase token used for backwards compatibility between new and old theming solutions"
      },
      "value": "uppercase"
    },
    "name": "utility.UNSAFE.textTransformUppercase",
    "path": [
      "utility",
      "UNSAFE",
      "textTransformUppercase"
    ],
    "cleanName": "utility.UNSAFE.textTransformUppercase"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "ALPHA - Use with caution. Use for main headings.",
      "responsiveSmallerVariant": "font.heading.xlarge"
    },
    "value": "normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography-adg3/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "ALPHA - Use with caution. Use for main headings.",
        "responsiveSmallerVariant": "font.heading.xlarge"
      },
      "value": {
        "fontWeight": "FontWeight500",
        "fontSize": "LegacyFontSize35",
        "lineHeight": "LineHeight700",
        "fontFamily": "FontFamilyWebSans",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing400"
      }
    },
    "name": "font.heading.xxlarge",
    "path": [
      "font",
      "heading",
      "xxlarge"
    ],
    "cleanName": "font.heading.xxlarge"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "ALPHA - Use with caution. Use for main headings.",
      "responsiveSmallerVariant": "font.heading.large"
    },
    "value": "normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography-adg3/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "ALPHA - Use with caution. Use for main headings.",
        "responsiveSmallerVariant": "font.heading.large"
      },
      "value": {
        "fontWeight": "FontWeight600",
        "fontSize": "LegacyFontSize29",
        "lineHeight": "LineHeight500",
        "fontFamily": "FontFamilyWebSans",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing400"
      }
    },
    "name": "font.heading.xlarge",
    "path": [
      "font",
      "heading",
      "xlarge"
    ],
    "cleanName": "font.heading.xlarge"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "ALPHA - Use with caution. Use for main headings.",
      "responsiveSmallerVariant": "font.heading.medium"
    },
    "value": "normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography-adg3/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "ALPHA - Use with caution. Use for main headings.",
        "responsiveSmallerVariant": "font.heading.medium"
      },
      "value": {
        "fontWeight": "FontWeight500",
        "fontSize": "FontSize24",
        "lineHeight": "LineHeight400",
        "fontFamily": "FontFamilyWebSans",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing400"
      }
    },
    "name": "font.heading.large",
    "path": [
      "font",
      "heading",
      "large"
    ],
    "cleanName": "font.heading.large"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "ALPHA - Use with caution. Use for less important headings.",
      "responsiveSmallerVariant": "font.heading.small"
    },
    "value": "normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography-adg3/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "ALPHA - Use with caution. Use for less important headings.",
        "responsiveSmallerVariant": "font.heading.small"
      },
      "value": {
        "fontWeight": "FontWeight500",
        "fontSize": "FontSize20",
        "lineHeight": "LineHeight300",
        "fontFamily": "FontFamilyWebSans",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing300"
      }
    },
    "name": "font.heading.medium",
    "path": [
      "font",
      "heading",
      "medium"
    ],
    "cleanName": "font.heading.medium"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "ALPHA - Use with caution. Use for less important headings."
    },
    "value": "normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography-adg3/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "ALPHA - Use with caution. Use for less important headings."
      },
      "value": {
        "fontWeight": "FontWeight600",
        "fontSize": "FontSize16",
        "lineHeight": "LineHeight200",
        "fontFamily": "FontFamilyWebSans",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing200"
      }
    },
    "name": "font.heading.small",
    "path": [
      "font",
      "heading",
      "small"
    ],
    "cleanName": "font.heading.small"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "ALPHA - Use with caution. Use for smaller headings."
    },
    "value": "normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography-adg3/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "ALPHA - Use with caution. Use for smaller headings."
      },
      "value": {
        "fontWeight": "FontWeight600",
        "fontSize": "FontSize14",
        "lineHeight": "LineHeight100",
        "fontFamily": "FontFamilyWebSans",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing100"
      }
    },
    "name": "font.heading.xsmall",
    "path": [
      "font",
      "heading",
      "xsmall"
    ],
    "cleanName": "font.heading.xsmall"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "ALPHA - Use with caution. Smallest heading size available."
    },
    "value": "normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography-adg3/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "ALPHA - Use with caution. Smallest heading size available."
      },
      "value": {
        "fontWeight": "FontWeight600",
        "fontSize": "FontSize12",
        "lineHeight": "LineHeight100",
        "fontFamily": "FontFamilyWebSans",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.heading.xxsmall",
    "path": [
      "font",
      "heading",
      "xxsmall"
    ],
    "cleanName": "font.heading.xxsmall"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "ALPHA - Use with caution. Larger body font or default body font for text rich experiences."
    },
    "value": "normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography-adg3/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "ALPHA - Use with caution. Larger body font or default body font for text rich experiences."
      },
      "value": {
        "fontWeight": "FontWeight400",
        "fontSize": "FontSize16",
        "lineHeight": "LineHeight300",
        "fontFamily": "FontFamilyWebSans",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.body.large",
    "path": [
      "font",
      "body",
      "large"
    ],
    "cleanName": "font.body.large"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "ALPHA - Use with caution. The default body font."
    },
    "value": "normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography-adg3/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "ALPHA - Use with caution. The default body font."
      },
      "value": {
        "fontWeight": "FontWeight400",
        "fontSize": "FontSize14",
        "lineHeight": "LineHeight200",
        "fontFamily": "FontFamilyWebSans",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.body.[default]",
    "path": [
      "font",
      "body",
      "[default]"
    ],
    "cleanName": "font.body"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "ALPHA - Use with caution. Smaller body font."
    },
    "value": "normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography-adg3/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "ALPHA - Use with caution. Smaller body font."
      },
      "value": {
        "fontWeight": "FontWeight400",
        "fontSize": "LegacyFontSize11",
        "lineHeight": "LineHeight100",
        "fontFamily": "FontFamilyWebSans",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.body.small",
    "path": [
      "font",
      "body",
      "small"
    ],
    "cleanName": "font.body.small"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "UNSAFE - Do not use. Temporary 12px fontsize token. Will be deprecated and replaced with stable small token"
    },
    "value": "normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography-adg3/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "UNSAFE - Do not use. Temporary 12px fontsize token. Will be deprecated and replaced with stable small token"
      },
      "value": {
        "fontWeight": "FontWeight400",
        "fontSize": "FontSize12",
        "lineHeight": "LineHeight100",
        "fontFamily": "FontFamilyWebSans",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.body.UNSAFE_small",
    "path": [
      "font",
      "body",
      "UNSAFE_small"
    ],
    "cleanName": "font.body.UNSAFE_small"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "deprecated",
      "introduced": "1.14.0",
      "deprecated": "1.39.0",
      "description": "ALPHA - Use with caution. Single-line non-wrapping text like that in a button."
    },
    "value": "normal 500 14px/1 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography-adg3/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "deprecated",
        "introduced": "1.14.0",
        "deprecated": "1.39.0",
        "description": "ALPHA - Use with caution. Single-line non-wrapping text like that in a button."
      },
      "value": {
        "fontWeight": "FontWeight500",
        "fontSize": "FontSize14",
        "lineHeight": "LineHeight1",
        "fontFamily": "FontFamilyWebSans",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.ui.[default]",
    "path": [
      "font",
      "ui",
      "[default]"
    ],
    "cleanName": "font.ui"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "deprecated",
      "introduced": "1.14.0",
      "deprecated": "1.39.0",
      "description": "ALPHA - Use with caution. Single-line non-wrapping supporting text like that in a smaller label."
    },
    "value": "normal 400 11px/1 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography-adg3/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "deprecated",
        "introduced": "1.14.0",
        "deprecated": "1.39.0",
        "description": "ALPHA - Use with caution. Single-line non-wrapping supporting text like that in a smaller label."
      },
      "value": {
        "fontWeight": "FontWeight400",
        "fontSize": "LegacyFontSize11",
        "lineHeight": "LineHeight1",
        "fontFamily": "FontFamilyWebSans",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.ui.small",
    "path": [
      "font",
      "ui",
      "small"
    ],
    "cleanName": "font.ui.small"
  },
  {
    "attributes": {
      "group": "typography",
      "state": "active",
      "introduced": "1.14.0",
      "description": "ALPHA - Use with caution. Used for monospace and code."
    },
    "value": "normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace",
    "filePath": "schema/themes/atlassian-typography-adg3/theme.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "typography",
        "state": "active",
        "introduced": "1.14.0",
        "description": "ALPHA - Use with caution. Used for monospace and code."
      },
      "value": {
        "fontWeight": "FontWeight400",
        "fontSize": "FontSizeCode",
        "lineHeight": "LineHeight1",
        "fontFamily": "FontFamilyWebMono",
        "fontStyle": "normal",
        "letterSpacing": "LetterSpacing0"
      }
    },
    "name": "font.code.[default]",
    "path": [
      "font",
      "code",
      "[default]"
    ],
    "cleanName": "font.code"
  },
  {
    "attributes": {
      "group": "letterSpacing",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "0",
    "filePath": "schema/themes/atlassian-typography-adg3/letter-spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "letterSpacing",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "LetterSpacing0"
    },
    "name": "font.letterSpacing.0",
    "path": [
      "font",
      "letterSpacing",
      "0"
    ],
    "cleanName": "font.letterSpacing.0"
  },
  {
    "attributes": {
      "group": "letterSpacing",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "-0.003em",
    "filePath": "schema/themes/atlassian-typography-adg3/letter-spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "letterSpacing",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "LetterSpacing100"
    },
    "name": "font.letterSpacing.100",
    "path": [
      "font",
      "letterSpacing",
      "100"
    ],
    "cleanName": "font.letterSpacing.100"
  },
  {
    "attributes": {
      "group": "letterSpacing",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "-0.006em",
    "filePath": "schema/themes/atlassian-typography-adg3/letter-spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "letterSpacing",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "LetterSpacing200"
    },
    "name": "font.letterSpacing.200",
    "path": [
      "font",
      "letterSpacing",
      "200"
    ],
    "cleanName": "font.letterSpacing.200"
  },
  {
    "attributes": {
      "group": "letterSpacing",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "-0.008em",
    "filePath": "schema/themes/atlassian-typography-adg3/letter-spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "letterSpacing",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "LetterSpacing300"
    },
    "name": "font.letterSpacing.300",
    "path": [
      "font",
      "letterSpacing",
      "300"
    ],
    "cleanName": "font.letterSpacing.300"
  },
  {
    "attributes": {
      "group": "letterSpacing",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "-0.01em",
    "filePath": "schema/themes/atlassian-typography-adg3/letter-spacing.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "letterSpacing",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "LetterSpacing400"
    },
    "name": "font.letterSpacing.400",
    "path": [
      "font",
      "letterSpacing",
      "400"
    ],
    "cleanName": "font.letterSpacing.400"
  },
  {
    "attributes": {
      "group": "fontFamily",
      "state": "deprecated",
      "introduced": "1.14.0",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography-adg3/font-family.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontFamily",
        "state": "deprecated",
        "introduced": "1.14.0",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "FontFamilyWebSans"
    },
    "name": "font.family.body",
    "path": [
      "font",
      "family",
      "body"
    ],
    "cleanName": "font.family.body"
  },
  {
    "attributes": {
      "group": "fontFamily",
      "state": "deprecated",
      "introduced": "1.14.0",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace",
    "filePath": "schema/themes/atlassian-typography-adg3/font-family.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontFamily",
        "state": "deprecated",
        "introduced": "1.14.0",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "FontFamilyWebMono"
    },
    "name": "font.family.code",
    "path": [
      "font",
      "family",
      "code"
    ],
    "cleanName": "font.family.code"
  },
  {
    "attributes": {
      "group": "fontFamily",
      "state": "deprecated",
      "introduced": "1.14.0",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography-adg3/font-family.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontFamily",
        "state": "deprecated",
        "introduced": "1.14.0",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "FontFamilyWebSans"
    },
    "name": "font.family.heading",
    "path": [
      "font",
      "family",
      "heading"
    ],
    "cleanName": "font.family.heading"
  },
  {
    "attributes": {
      "group": "fontFamily",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace",
    "filePath": "schema/themes/atlassian-typography-adg3/font-family.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontFamily",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "FontFamilyWebMono"
    },
    "name": "font.family.monospace",
    "path": [
      "font",
      "family",
      "monospace"
    ],
    "cleanName": "font.family.monospace"
  },
  {
    "attributes": {
      "group": "fontFamily",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography-adg3/font-family.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontFamily",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "LegacyFontFamilyWebSans"
    },
    "name": "font.family.sans",
    "path": [
      "font",
      "family",
      "sans"
    ],
    "cleanName": "font.family.sans"
  },
  {
    "attributes": {
      "group": "fontFamily",
      "state": "active",
      "introduced": "1.14.0",
      "description": "Use for branded body text."
    },
    "value": "\"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography-adg3/font-family.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontFamily",
        "state": "active",
        "introduced": "1.14.0",
        "description": "Use for branded body text."
      },
      "value": "FontFamilyCharlieText"
    },
    "name": "font.family.brand.body",
    "path": [
      "font",
      "family",
      "brand",
      "body"
    ],
    "cleanName": "font.family.brand.body"
  },
  {
    "attributes": {
      "group": "fontFamily",
      "state": "active",
      "introduced": "1.14.0",
      "description": "Use for branded headings."
    },
    "value": "\"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif",
    "filePath": "schema/themes/atlassian-typography-adg3/font-family.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontFamily",
        "state": "active",
        "introduced": "1.14.0",
        "description": "Use for branded headings."
      },
      "value": "FontFamilyCharlieDisplay"
    },
    "name": "font.family.brand.heading",
    "path": [
      "font",
      "family",
      "brand",
      "heading"
    ],
    "cleanName": "font.family.brand.heading"
  },
  {
    "attributes": {
      "group": "fontSize",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "11px",
    "filePath": "schema/themes/atlassian-typography-adg3/font-size.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontSize",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "LegacyFontSize11"
    },
    "name": "font.size.050",
    "path": [
      "font",
      "size",
      "050"
    ],
    "cleanName": "font.size.050"
  },
  {
    "attributes": {
      "group": "fontSize",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "12px",
    "filePath": "schema/themes/atlassian-typography-adg3/font-size.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontSize",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "FontSize12"
    },
    "name": "font.size.075",
    "path": [
      "font",
      "size",
      "075"
    ],
    "cleanName": "font.size.075"
  },
  {
    "attributes": {
      "group": "fontSize",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "14px",
    "filePath": "schema/themes/atlassian-typography-adg3/font-size.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontSize",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "FontSize14"
    },
    "name": "font.size.100",
    "path": [
      "font",
      "size",
      "100"
    ],
    "cleanName": "font.size.100"
  },
  {
    "attributes": {
      "group": "fontSize",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "16px",
    "filePath": "schema/themes/atlassian-typography-adg3/font-size.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontSize",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "FontSize16"
    },
    "name": "font.size.200",
    "path": [
      "font",
      "size",
      "200"
    ],
    "cleanName": "font.size.200"
  },
  {
    "attributes": {
      "group": "fontSize",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "20px",
    "filePath": "schema/themes/atlassian-typography-adg3/font-size.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontSize",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "FontSize20"
    },
    "name": "font.size.300",
    "path": [
      "font",
      "size",
      "300"
    ],
    "cleanName": "font.size.300"
  },
  {
    "attributes": {
      "group": "fontSize",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "24px",
    "filePath": "schema/themes/atlassian-typography-adg3/font-size.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontSize",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "FontSize24"
    },
    "name": "font.size.400",
    "path": [
      "font",
      "size",
      "400"
    ],
    "cleanName": "font.size.400"
  },
  {
    "attributes": {
      "group": "fontSize",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "29px",
    "filePath": "schema/themes/atlassian-typography-adg3/font-size.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontSize",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "LegacyFontSize29"
    },
    "name": "font.size.500",
    "path": [
      "font",
      "size",
      "500"
    ],
    "cleanName": "font.size.500"
  },
  {
    "attributes": {
      "group": "fontSize",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "35px",
    "filePath": "schema/themes/atlassian-typography-adg3/font-size.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontSize",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "LegacyFontSize35"
    },
    "name": "font.size.600",
    "path": [
      "font",
      "size",
      "600"
    ],
    "cleanName": "font.size.600"
  },
  {
    "attributes": {
      "group": "fontWeight",
      "state": "active",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here"
    },
    "value": "700",
    "filePath": "schema/themes/atlassian-typography-adg3/font-weight.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontWeight",
        "state": "active",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here"
      },
      "value": "FontWeight700"
    },
    "name": "font.weight.bold",
    "path": [
      "font",
      "weight",
      "bold"
    ],
    "cleanName": "font.weight.bold"
  },
  {
    "attributes": {
      "group": "fontWeight",
      "state": "active",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here"
    },
    "value": "500",
    "filePath": "schema/themes/atlassian-typography-adg3/font-weight.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontWeight",
        "state": "active",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here"
      },
      "value": "FontWeight500"
    },
    "name": "font.weight.medium",
    "path": [
      "font",
      "weight",
      "medium"
    ],
    "cleanName": "font.weight.medium"
  },
  {
    "attributes": {
      "group": "fontWeight",
      "state": "active",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here"
    },
    "value": "400",
    "filePath": "schema/themes/atlassian-typography-adg3/font-weight.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontWeight",
        "state": "active",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here"
      },
      "value": "FontWeight400"
    },
    "name": "font.weight.regular",
    "path": [
      "font",
      "weight",
      "regular"
    ],
    "cleanName": "font.weight.regular"
  },
  {
    "attributes": {
      "group": "fontWeight",
      "state": "active",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here"
    },
    "value": "600",
    "filePath": "schema/themes/atlassian-typography-adg3/font-weight.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "fontWeight",
        "state": "active",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here"
      },
      "value": "FontWeight600"
    },
    "name": "font.weight.semibold",
    "path": [
      "font",
      "weight",
      "semibold"
    ],
    "cleanName": "font.weight.semibold"
  },
  {
    "attributes": {
      "group": "lineHeight",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Used single-line text.",
      "deprecated": "1.29.0"
    },
    "value": "1",
    "filePath": "schema/themes/atlassian-typography-adg3/line-height.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "lineHeight",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Used single-line text.",
        "deprecated": "1.29.0"
      },
      "value": "LineHeight1"
    },
    "name": "font.lineHeight.1",
    "path": [
      "font",
      "lineHeight",
      "1"
    ],
    "cleanName": "font.lineHeight.1"
  },
  {
    "attributes": {
      "group": "lineHeight",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "16px",
    "filePath": "schema/themes/atlassian-typography-adg3/line-height.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "lineHeight",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "LineHeight100"
    },
    "name": "font.lineHeight.100",
    "path": [
      "font",
      "lineHeight",
      "100"
    ],
    "cleanName": "font.lineHeight.100"
  },
  {
    "attributes": {
      "group": "lineHeight",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "20px",
    "filePath": "schema/themes/atlassian-typography-adg3/line-height.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "lineHeight",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "LineHeight200"
    },
    "name": "font.lineHeight.200",
    "path": [
      "font",
      "lineHeight",
      "200"
    ],
    "cleanName": "font.lineHeight.200"
  },
  {
    "attributes": {
      "group": "lineHeight",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "24px",
    "filePath": "schema/themes/atlassian-typography-adg3/line-height.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "lineHeight",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "LineHeight300"
    },
    "name": "font.lineHeight.300",
    "path": [
      "font",
      "lineHeight",
      "300"
    ],
    "cleanName": "font.lineHeight.300"
  },
  {
    "attributes": {
      "group": "lineHeight",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "28px",
    "filePath": "schema/themes/atlassian-typography-adg3/line-height.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "lineHeight",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "LineHeight400"
    },
    "name": "font.lineHeight.400",
    "path": [
      "font",
      "lineHeight",
      "400"
    ],
    "cleanName": "font.lineHeight.400"
  },
  {
    "attributes": {
      "group": "lineHeight",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "32px",
    "filePath": "schema/themes/atlassian-typography-adg3/line-height.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "lineHeight",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "LineHeight500"
    },
    "name": "font.lineHeight.500",
    "path": [
      "font",
      "lineHeight",
      "500"
    ],
    "cleanName": "font.lineHeight.500"
  },
  {
    "attributes": {
      "group": "lineHeight",
      "state": "deprecated",
      "introduced": "0.10.33",
      "description": "Helpful guidance goes here",
      "deprecated": "1.29.0"
    },
    "value": "40px",
    "filePath": "schema/themes/atlassian-typography-adg3/line-height.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "lineHeight",
        "state": "deprecated",
        "introduced": "0.10.33",
        "description": "Helpful guidance goes here",
        "deprecated": "1.29.0"
      },
      "value": "LineHeight700"
    },
    "name": "font.lineHeight.600",
    "path": [
      "font",
      "lineHeight",
      "600"
    ],
    "cleanName": "font.lineHeight.600"
  }
];

export default tokens;
